<script lang="tsx" setup>
import useThreatColumns from './threatColumns'
import FilterContainer from '@/components/filter/FilterContainer.vue'
import { useI18n } from 'vue-i18n'
import TextFilter from '@/components/filter/TextFilter.vue'
import InstanceFilter from '@/components/filter/InstanceFilter.vue'
import MultiSelectFilter from '@/components/filter/MultiSelectFilter.vue'
import { TextField, ValueField } from '@/models/select-item'
import { getInfoSecCoreText } from '@/services/utils'
import RiskCategoryFilter from '@/components/filter/RiskCategoryFilter.vue'
import RiskCatalogFilter from '@/components/filter/RiskCatalogFilter.vue'

const props = defineProps<{
	component: string
}>()

const { t } = useI18n()
const { columns, custom, all } = useThreatColumns(props.component)
</script>

<template>
	<FilterContainer :columns="all" :custom="custom" bookmark="threats-bookmark">
		<div class="p-2 filter-col" v-if="columns.name.value.isVisible">
			<TextFilter id="name-filter-threat" v-model="columns.name.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.comment.value.isVisible">
			<TextFilter id="comment-filter-threat" v-model="columns.comment.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.code.value.isVisible">
			<TextFilter id="code-filter-threat" v-model="columns.code.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.catalog.value.isVisible">
			<RiskCatalogFilter id="catalog-filter-threat" v-model="columns.catalog.value"></RiskCatalogFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.category.value.isVisible">
			<RiskCategoryFilter id="category-filter-threat" v-model="columns.category.value"></RiskCategoryFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.impact.value.isVisible">
			<TextFilter id="impact-filter-threat" v-model="columns.impact.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-show="columns.instance.value.isVisible">
			<InstanceFilter id="instance-filter-threat" v-model="columns.instance.value"></InstanceFilter>
		</div>
		<div class="p-2 filter-col" v-if="columns.description.value.isVisible">
			<TextFilter id="description-filter-threat" v-model="columns.description.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.cia.value.isVisible">
			<MultiSelectFilter
				id="cia-filter-threat"
				v-model="columns.cia.value"
				:label-field="TextField"
				:value-field="ValueField"
				:formatter="getInfoSecCoreText"
				:options="[
					{ text: t('confidentiality'), value: 'confidentiality' },
					{ text: t('integrity'), value: 'integrity' },
					{ text: t('availability'), value: 'availability' },
				]"
			></MultiSelectFilter>
		</div>

		<!-- to-do: add score filter  -->
	</FilterContainer>
</template>
